import { environment } from '../../environment'
import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'
import { defaultUserState } from './data';
import { userIsAdmin, userIsMediator } from './services';
import { UseUserStore } from './models';

export const useUserStore = create<UseUserStore>(
  devtools
    (persist((set, get) => ({
      ...defaultUserState,
      setJwt: (jwt) => set({ jwt }),
      setUserId: (id) => set({ id }),
      userIsAdmin: userIsAdmin(set,get),
      userIsMediator: userIsMediator(set,get),
      setClub: (club) => set({ club }),
      setClubUser: (clubUser) => set({ clubUser }),
      setClubs: (clubs) => set({ clubs }),
      setProfile: (profile) => set({ profile }),
      reset:()=> set({...defaultUserState}),
      getProfile: () => get().profile,
    }),{
      name: '@zustand/useUserStore',
      version: environment.zustandStoreVersion
    }))
)

export const UserStore = useUserStore.getState()
